const messages = {
  title: "Prislister og produktbrochurer",
  title_media: "Prislister og produktbrochurer",
  description:
    "Download her de seneste brochurer og flyers om vores Bridgestone- og Firestone-dæk til personbiler, SUV'er og erhvervskøretøjer.",
  short_description:
    "Her kan du finde materiale til sociale medier, in-store TV og mere.",
  mediaCategories: {
    products: "Produkter",
    brand_and_solutions: "Brand og løsninger",
    season_and_promotions: "Sæson og kampagner",
    format: "Format",
    cars_and_vans: "Bil, SUV, forsyning",
    truck_and_buses: "Tunge lastbiler og busser",
    motorcycle: "Motorcykel",
    agriculture: "Landbrug",
    construction_machinery: "Entreprenørmaskiner",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materialer",
    brochures: "Produktbrochurer",
    price_list: "Prislister",
    materials: "Materialer",
    video_in_store: "Video med undertekster",
    video_online: "Video uden undertekster",
    video: "Video",
    banner_website: "Banner",
    banner_social_media: "Sociale netværk",
    logos: "Logoer",
    summer: "Sommer",
    winter: "Vinter",
    all_season: "Alle årstider",
    promotions: "Kampagner",
    price: "Pricat",
  },
  mediasPage: {
    title: "MEDIEBIBLIOTEK",
    description:
      "Velkommen til medieafdelingen dedikeret   \n" +
      "til Bridgestone og Firestone produkter.  \n <br> <br>" +
      "Du vil opdage produktvisualiseringer,   \n" +
      "logoer, samt et bredt udvalg af   \n" +
      "bannere, videoer og digitale materialer   \n" +
      "til brug på din hjemmeside eller på   \n" +
      "de sociale medier.  ",
    bDrive: {
      title: "Produktfotos",
      description:
        "Aktuelle billeder   \n" +
        "kan downloades   \n" +
        "fra vores B-\n" +
        "DRIVE portal.  ",
    },
  },
  buttons: {
    media: "OPDAG",
  },
  searchMedia: "Indtast søgeord",
  searchResults: "Søgeresultater",
};

export default {
  messages,
};
